import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Debug interceptor
api.interceptors.request.use((config) => {
  console.log(`Request: ${config.method.toUpperCase()} ${config.url}`, config.headers);
  return config;
});

// Tiered Auth Interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('choir_token');
  const sharedPassword = localStorage.getItem('rehearsal_password');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (sharedPassword) {
    config.headers['X-Shared-Password'] = sharedPassword;
  }
  
  return config;
});

export const songService = {
  searchSongs: async (query, voicePart = null, collection = null) => {
    const params = { q: query };
    if (voicePart) params.part = voicePart;
    if (collection) params.collection = collection;
    
    const response = await api.get('/choir/search', { params });
    return response.data;
  },

  getSongDetail: async (slug) => {
    const response = await api.get(`/choir/songs/${slug}`);
    return response.data;
  },

  // System Health
  checkHealth: async () => {
    const response = await axios.get('/health');
    return response.data;
  }
};

export const authService = {
  verifyPassword: async (password) => {
    // Make a lightweight, un-cached request to verify the password before letting the user in
    const response = await axios.get(`${API_BASE_URL}/choir/search`, {
      params: { q: 'test', limit: 1 },
      headers: { 'X-Shared-Password': password }
    });
    return response.status === 200;
  }
};

// Global Error Handler
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response ? error.response.data : error.message);
    return Promise.reject(error);
  }
);
